import React from "react"
import { Component } from "react";
let check_icon = require('../../../theme/assets/images/check-box-brown.png')
class OwnerPhoneVerification extends Component {
    render() {
        return(
            <div className="verified_check_block">
                <img src={check_icon} className="check_icon_image" alt="check-icon"/>
                <p className="verification_confirmation_text"> Phone Number Verified</p>
            </div>
        );
    }
}
export default OwnerPhoneVerification